import { notification } from 'antd';
import React from 'react';
import CheckCircle from '@svg/v-circle-green.svg?react';
import WarningIcon from '@svg/warning.svg?react';
import InfoIcon from '@svg/info-circle.svg?react';
import ErrorIcon from '@svg/x-circle-transparent.svg?react';
import CloseIcon from '@svg/close-x-white.svg?react';
import { NotificationType } from '../../utils/enums';
import { NotificationPlacement } from 'antd/lib/notification';

const toastsMap = {
    [NotificationType.SUCCESS]: {
        icon: <CheckCircle/>
    },
    [NotificationType.INFO]: {
        icon: <InfoIcon/>
    },
    [NotificationType.WARNING]: {
        icon: <WarningIcon/>
    },
    [NotificationType.ERROR]: {
        icon: <ErrorIcon/>
    }
};

export const toast = (notificationType: NotificationType, notificationMsg: string, placement:NotificationPlacement = 'bottom') => notification.open({
    type: notificationType,
    message: notificationMsg,
    description: '',
    placement: placement,
    className: 'toast',
    duration: 6,
    icon: toastsMap[notificationType].icon,
    closeIcon: <CloseIcon />
});